import './story-videos.scss';

import StoryVideos from './StoryVideos';

export default StoryVideos;
